export default "__VITE_ASSET__BU2oOU7U__"